import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  RFQ_LIST,
  RFQ_ROW_DATA,
  Q_VENDORS_LIST,
  QUOTATION_ADD,
  QUOTATION_LIST,
  Q_MODEL_LIST_OPEN,
  QOUTATION_DATA,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  RFQ_FILTERS_LIST,
  MR_CODE_DETAILS,
  PI_CODE_DETAILS,
  MR_ITEM_IMAGES,
  SRFQ_FILTERS_LIST,
  RFQ_WITHOUT_PO_LIST,
} from "./actionTypes";
import {
  apiError,
  getRFQListSuccessful,
  getRFQRequestdataSuccessful,
  getQuotationtVendorsList,
  QuotationtVendorsListSuccessful,
  QuotationtListSuccessful,
  QuotationDatasuccessfull,
  getRFQFilterListSuccessful,
  getMRCodeDetailsSuccessful,
  getPICodeDetailsSuccessful,
  getMRItemImgesSuccessful,
  getSRFQFilterListSuccessful,
  getRFQWithoutPOListSuccessful,
} from "./actions";

import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
} from "../../helpers/Helper";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { generateQuotationPDF } from "../../helpers/quotationPdfGenerator";

function* getRFQList() {
  try {
    const response = yield call(
      getList,
      "/requestforquotation/Quotation/list",
      {},
    );
    yield put(getRFQListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQfilterList() {
  try {
    const response = yield call(getList, "/requestforquotation/All/list", {});
    yield put(getRFQFilterListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQRowdata({ payload: { rfqId, byVendor } }) {
  try {
    const response = yield call(getList, "/requestforquotation/" + rfqId, {});
    console.log("[RFQ Row Data] Response:", response);
    yield put(getRFQRequestdataSuccessful(response));
    if (!byVendor) {
      yield put(getQuotationtVendorsList(rfqId));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getSRFQfilterList() {
  try {
    const response = yield call(
      getList,
      "/servicerequestforquotation/All/list",
      {},
    );
    yield put(getSRFQFilterListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQWithoutPOList() {
  try {
    const response = yield call(
      getList,
      "/requestforquotation/WithoutPO/list",
      {},
    );
    yield put(getRFQWithoutPOListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetVendorData({ payload: { rfqId } }) {
  try {
    const response = yield call(getList, "/quotation/vendorbyrfq/" + rfqId, {});
    yield put(QuotationtVendorsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddQoutation({ payload: { data, qoutId, history } }) {
  console.log("[AddQoutation] Payload received:", { data, qoutId, history });

  try {
    if (qoutId === 0) {
      let response = {};
      let dataToSend = { ...data };

      if (dataToSend.token === "") {
        delete dataToSend.token;
        console.log("[AddQoutation] Removed empty token field");
      }

      if (data.token !== "") {
        console.log("[AddQoutation] Vendor submission");

        response = yield call(postAdd, "/quotation/add/vendor", dataToSend);

        console.log("[AddQoutation] Vendor Response:", response);
      } else {
        console.log("[AddQoutation] Internal user submission");

        response = yield call(postAdd, "/quotation/", dataToSend);

        console.log("[AddQoutation] Internal Response:", response);
      }

      console.log("[AddQoutation] Status:", response.status);
      console.log("[AddQoutation] Dataeeeeeeeeeeeeeeeeee:", response.data);

      if (response.status === 201) {
        console.log("[AddQoutation] SUCCESSggggggggggggggggggggggggggggggg");

        swal("Your Quotation Added Successfully.!", {
          icon: "success",
        });

        if (data.token !== "") {
          const qData = response?.data?.data || response?.data;
          console.log("[AddQoutation] Generating PDF for:", qData?.code);
          console.log("[PDF Debug] qData keys:", Object.keys(qData));
          console.log(
            "[PDF Debug] first qitem:",
            JSON.stringify(qData.qitems?.[0], null, 2),
          );
          try {
            generateQuotationPDF(qData);
            console.log("[AddQoutation] PDF downloaded");
          } catch (pdfErr) {
            console.error("[AddQoutation] PDF generation failed:", pdfErr);
          }
          setTimeout(() => {
            window.location.href = "/vendorlogin";
          }, 1500);
        } else {
          history.push("/quotationdashboard");
        }
      } else {
        console.log("[AddQoutation] FAILED");

        swal("Sorry! Unable to add quotation. Please try again!", {
          icon: "error",
        });
      }
    } else {
      console.log("[AddQoutation] Edit mode:", qoutId);

      delete data.vendor_id;

      const response = yield call(postEdit, "/quotation/" + qoutId, data);

      console.log("[AddQoutation] Edit Response:", response);

      if (response.status === 200) {
        swal("Your quotation Edited Successfully.!", {
          icon: "success",
        });

        history.push("/quotationdashboard");
      } else {
        swal("Sorry! Unable to edit quotation. Please try again!", {
          icon: "error",
        });
      }
    }
  } catch (error) {
    console.error("[AddQoutation] ERROR:", error);

    if (data.token !== "") {
      Swal.fire({
        icon: "error",
        text: "Quotation already submitted!",
        confirmButtonText: "Ok",
      }).then(() => {
        window.location.href = "/vendorlogin";
      });
    } else {
      Swal.fire({
        icon: "error",
        text: "Please Try Again!",
      });
    }

    yield put(apiError(error));
  }
}

function* getQuotationList({ payload: { data } }) {
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/quotation/list", params);

    yield put(QuotationtListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getQuotationRowdata({ payload: { qId } }) {
  try {
    const response = yield call(getList, "/quotation/" + qId, {});
    yield put(
      QuotationDatasuccessfull({
        response: {
          ...response,

          vendor_id: response.vendor ? response.vendor.id : 0,
          vendLabel: response.vendor ? response.vendor.name : "",
        },
      }),
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getMRCodeDetails({ payload: { ItemId } }) {
  try {
    const response = yield call(
      getList,
      "/quotation/mrcodebyqitem/" + ItemId,
      {},
    );
    yield put(getMRCodeDetailsSuccessful({ ItemId, data: response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getPICodeDetails({ payload: { ItemId } }) {
  try {
    const response = yield call(
      getList,
      "/quotation/picodebyqitem/" + ItemId,
      {},
    );
    yield put(getPICodeDetailsSuccessful({ ItemId, data: response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQMRItemImges({ payload: { rfqItemId } }) {
  try {
    const response = yield call(
      getList,
      "/requestforquotation/mrcodebyrfqitem/" + rfqItemId,
      {},
    );
    yield put(getMRItemImgesSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function manageBodyClass(cssClass, action = "toggle") {
  switch (action) {
    case "add":
      if (document.body) document.body.classList.add(cssClass);
      break;
    case "remove":
      if (document.body) document.body.classList.remove(cssClass);
      break;
    default:
      if (document.body) document.body.classList.toggle(cssClass);
      break;
  }

  return true;
}
function* FilterShowRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled");
  } catch (error) {}
}
function* FilterHideRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
  } catch (error) {}
}
export function* watchgetRFQList() {
  yield takeEvery(RFQ_LIST, getRFQList);
}
export function* watchgetRFQRowdata() {
  yield takeEvery(RFQ_ROW_DATA, getRFQRowdata);
}
export function* watchQoutationAdd() {
  yield takeEvery(QUOTATION_ADD, AddQoutation);
}
export function* watchgetQuotationList() {
  yield takeEvery(QUOTATION_LIST, getQuotationList);
}
export function* watchmodellist() {
  yield takeEvery(Q_MODEL_LIST_OPEN, getQuotationRowdata);
}
export function* watchQuotationData() {
  yield takeEvery(QOUTATION_DATA, getQuotationRowdata);
}
export function* watchGetVendorData() {
  yield takeEvery(Q_VENDORS_LIST, GetVendorData);
}

export function* watchFilterShowRightSidebar() {
  yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
  yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchgetRFQFilterList() {
  yield takeEvery(RFQ_FILTERS_LIST, getRFQfilterList);
}
export function* watchgetSRFQFilterList() {
  yield takeEvery(SRFQ_FILTERS_LIST, getSRFQfilterList);
}
export function* watchgetMRCodeDetails() {
  yield takeEvery(MR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchgetPICodeDetails() {
  yield takeEvery(PI_CODE_DETAILS, getPICodeDetails);
}
export function* watchgetMRItemData() {
  yield takeEvery(MR_ITEM_IMAGES, getRFQMRItemImges);
}
export function* watchgetRFQWithoutPOList() {
  yield takeEvery(RFQ_WITHOUT_PO_LIST, getRFQWithoutPOList);
}
function* QuotationSaga() {
  yield all([
    fork(watchgetRFQList),
    fork(watchgetRFQRowdata),
    fork(watchGetVendorData),
    fork(watchQoutationAdd),
    fork(watchgetQuotationList),
    fork(watchmodellist),
    fork(watchQuotationData),

    fork(watchFilterShowRightSidebar),
    fork(watchfilterHideRightSidebarr),
    fork(watchgetRFQFilterList),
    fork(watchgetSRFQFilterList),
    fork(watchgetMRCodeDetails),
    fork(watchgetPICodeDetails),
    fork(watchgetMRItemData),
    fork(watchgetRFQWithoutPOList),
  ]);
}

export default QuotationSaga;
